import { ApolloError } from '@apollo/client';
import { CreateRodRequestCaddyErrorCode, CreateRodrequestCaddyError } from '@bechtel/types';

export type CreateRodRequestErrorType = CreateRodRequestCaddyErrorCode | ApolloError;

export interface CreateRodRequestErrorProps {
  errorCaddies: CreateRodrequestCaddyError[] | null;
  error: CreateRodRequestErrorType | null;
  onClose: () => void;
}
